import { useToastStore, type Toast } from '@/stores/toast.store';

const TOAST_COLORS: Record<Toast['type'], { background: string; border: string; color: string }> = {
  error: { background: 'var(--danger-bg)', border: 'var(--danger-2)', color: 'var(--danger-2)' },
  success: {
    background: 'var(--success-bg)',
    border: 'var(--success-border)',
    color: 'var(--success-text)',
  },
  info: { background: 'var(--bg-card)', border: 'var(--border)', color: 'var(--text)' },
};

export function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts);
  const removeToast = useToastStore((s) => s.removeToast);

  if (toasts.length === 0) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        zIndex: 1000,
        maxWidth: 360,
      }}
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          onClick={() => removeToast(toast.id)}
          style={{
            background: TOAST_COLORS[toast.type].background,
            border: `1px solid ${TOAST_COLORS[toast.type].border}`,
            color: TOAST_COLORS[toast.type].color,
            borderRadius: 8,
            padding: '10px 14px',
            fontSize: 13,
            fontWeight: 600,
            cursor: 'pointer',
            boxShadow: '0 10px 25px rgba(0,0,0,0.3)',
            animation: 'toast-in 0.15s ease-out',
          }}
        >
          {toast.message}
        </div>
      ))}
    </div>
  );
}
